const state = {
  customers: [],
  page: 1,
  search: '',
  searchMessages: false,
  status: 'active',
  categories: [],
  myCustomers: true,
  read: null,
  unreadMessages: false,
  premiumUsers: false,
  toManage: false,
  clavedat: [],
};

// Filtros de «Restaurar filtros»; también completan un filtro guardado al que le falte alguno
function defaultFilters(rootGetters) {
  return {
    search: '',
    searchMessages: false,
    myCustomers: true,
    status: 'active',
    customers: [],
    categories: rootGetters.userCategoriesNames,
    read: null,
    unreadMessages: false,
    premiumUsers: false,
    toManage: false,
    clavedat: [],
  };
}

const getters = {
  // Lo que se guarda en «Filtros guardados»: todos los filtros salvo la página
  savedFilters(state) {
    return {
      search: state.search,
      searchMessages: state.searchMessages,
      myCustomers: state.myCustomers,
      status: state.status,
      customers: state.customers,
      categories: state.categories,
      read: state.read,
      unreadMessages: state.unreadMessages,
      premiumUsers: state.premiumUsers,
      toManage: state.toManage,
      clavedat: state.clavedat,
    };
  },

  // Parámetros de GET /admin/conversations; los vacíos no se envían
  params(state) {
    const params = {
      q: state.search ? state.search.trim() : '',
      search_messages: state.searchMessages,
      status: state.status,
      categories: state.categories,
      read: state.read,
      unread_messages: state.unreadMessages,
      to_manage: state.toManage,
      my_customers: state.myCustomers,
      premium: state.premiumUsers,
      customers: state.customers,
      clavedat: state.clavedat,
      page: state.page,
    };
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (
        value === null ||
        value === '' ||
        value === false ||
        (Array.isArray(value) && !value.length)
      ) {
        delete params[key];
      }
    });
    return params;
  },

  clavedat(state) {
    return state.clavedat;
  },
  search(state) {
    return state.search;
  },
  searchMessages(state) {
    return state.searchMessages;
  },
  myCustomers(state) {
    return state.myCustomers;
  },
  status(state) {
    return state.status;
  },
  customers(state) {
    return state.customers;
  },
  categories(state) {
    return state.categories;
  },
  page(state) {
    return state.page;
  },
  read(state) {
    return state.read;
  },
  unreadMessages(state) {
    return state.unreadMessages;
  },
  premiumUsers(state) {
    return state.premiumUsers;
  },
  toManage(state) {
    return state.toManage;
  },
};

const mutations = {
  params(state, data) {
    state.search = data.search;
    state.searchMessages = data.searchMessages;
    state.myCustomers = data.myCustomers;
    state.status = data.status;
    state.customers = data.users;
    state.categories = data.categories;
    state.page = data.page;
    state.read = data.read;
    state.unreadMessages = data.unreadMessages;
    state.premiumUsers = data.premiumUsers;
    state.toManage = data.toManage;
  },

  clavedat(state, data) {
    state.clavedat = data;
  },

  customers(state, data) {
    state.page = 1;
    state.customers = data;
  },
  page(state, data) {
    state.page = data;
  },
  search(state, data) {
    state.page = 1;
    state.search = data;
  },
  searchMessages(state, data) {
    state.page = 1;
    state.searchMessages = data;
  },
  status(state, data) {
    state.page = 1;
    state.status = data;
  },
  categories(state, data) {
    state.page = 1;
    state.categories = data;
  },
  myCustomers(state, data) {
    state.page = 1;
    state.myCustomers = data;
  },
  read(state, data) {
    state.page = 1;
    state.read = data;
  },
  unreadMessages(state, data) {
    state.page = 1;
    state.unreadMessages = data;
  },
  premiumUsers(state, data) {
    state.page = 1;
    state.premiumUsers = data;
  },
  toManage(state, data) {
    state.page = 1;
    state.toManage = data;
  },
};

const actions = {
  resetParams: function({ commit, rootGetters }) {
    const filters = defaultFilters(rootGetters);
    commit('params', Object.assign({}, filters, { users: filters.customers, page: 1 }));
    commit('clavedat', filters.clavedat);
  },

  applySavedFilters: function({ commit, rootGetters }, saved) {
    const filters = Object.assign(defaultFilters(rootGetters), saved);
    commit('params', Object.assign({}, filters, { users: filters.customers, page: 1 }));
    commit('clavedat', filters.clavedat);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
